const AVATAR_SIZE = 32;
const BORDER_WIDTH = 2;

export const wrapperStyles = {
  display: 'inline-flex',
  width: `${AVATAR_SIZE}px`,
  height: `${AVATAR_SIZE}px`,
  flexShrink: 0,
};

export const getAvatarStyles = color => ({
  width: `${AVATAR_SIZE}px`,
  height: `${AVATAR_SIZE}px`,
  border: `${BORDER_WIDTH}px solid`,
  borderColor: ({ palette }) => color?.bg || palette.grey[300],
  backgroundColor: ({ palette }) => palette.background.paper,
  color: ({ palette }) => palette.text.secondary,
});
